import './src/main.css'
import DigitalFlop from './src/main.vue'

export default function (Vue) {
  Vue.component(DigitalFlop.name, DigitalFlop)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/digitalFlop/index.js